import React from "react";
import Slider from "react-slick";
import "../../styles/style.css";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import ArrowRightIcon from "../../assets/images/arrow-right.png";
import bed from "../../assets/images/bed.png";
import { Link } from "react-router-dom";
import BASE from "../../config";
import stripHTMLTags from "../../functions";


const settings = {
  slidesToShow: 3.5,
  slidesToScroll: 1,
  centerMode: false,
  infinite: false,
  speed: 300,
  arrows: true,
  dots: false,
  centerPadding: "0",
  rtl: false,
  initialSlide: 0,
  responsive: [
    {
      breakpoint: 1024,
      settings: { slidesToShow: 2.5, slidesToScroll: 1, centerMode: false, infinite: false },
    },
    {
      breakpoint: 768,
      settings: { slidesToShow: 1.5, slidesToScroll: 1, centerMode: false, infinite: false },
    },
  ],
};

const Villas = ({ resorts }) => {
  if (!resorts?.length) return null;

  return (
    <div className="luxury_villas">
      <div className="slider_area_villas desktop">
        <div className="slider-container">
          <div className="slider_heading">
            <h1>Luxury Villa Collection</h1>
          </div>

          <Slider key={resorts.map((r) => r.id).join("-")} {...settings}>
            {resorts.map((items, index) => (
              <div key={items.id ?? index} className="slider-item">
                <div className="slider_inner_content">
                  <Link
                    to={`/${items.title.toLowerCase().replace(/\s+/g, "-")}/${items.id}`}
                  >
                    <img
                      style={{ height: "300px" }}
                      src={BASE.BASE_IMAGES_PATH + "/categories/" + items.image}
                      alt={items.title || "Resort"}
                    />
                  </Link>

                  <div className="inner_data_slider">
                    <Link
                      className="resorts-title"
                      to={`/${items.title.toLowerCase().replace(/\s+/g, "-")}/${items.id}`}
                    >
                      <h3>{items.title}</h3>
                    </Link>
                    <p>
                      {stripHTMLTags(items.description)
                        .replace(/&nbsp;/g, " ")
                        .replace(/&euro;/g, "€")
                        .replace(/&rsquo;/g, "'")
                        .substring(0, 180)}{" "}
                      ...
                    </p>

                    <div className="bedrooms_villas">
                      <div className="bedrooms_villas_left">
                        <p>
                          2-5
                          <span role="img" aria-label="bed">
                            {" "}
                            <img src={bed} alt="" />
                          </span>
                          Room
                        </p>
                      </div>

                      <div className="bedrooms_villas_right">
                        <Link
                          to={`/${items.title
                            .toLowerCase()
                            .replace(/\s+/g, "-")}/${items.id}`}
                        >
                          View More
                          <img
                            src={ArrowRightIcon}
                            alt="Arrow Right"
                            className="arrow_icon"
                            style={{
                              marginLeft: "10px",
                              width: "12px",
                              height: "12px",
                              marginTop: "5px",
                            }}
                          />
                        </Link>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            ))}
          </Slider>
        </div>
      </div>
    </div>
  );
};

export default Villas;
